module.exports = __webpack_public_path__ + "static/tlo_palenie-fa3963245c1146d31e4e1ba8786e748f.png";